import { Navigate } from 'react-router';

import { useAtomValue } from 'jotai';
import { userState } from '../../state/UIState';
import { canSeeConfig } from '../../constants/constants';
import { firstRole } from '../../utils/roles';

export function DefaultPageRedirect() {
  const user = useAtomValue(userState);

  // Multi-role: land on the default page of the user's MOST IMPORTANT held role (firstRole via ROLE_ORDER).
  // For single-role users this is just their role; a Manager-Submitter lands on the Manager page, and an
  // X+Admin user lands on X's page (ADMIN is last in ROLE_ORDER) while an admin-only user lands on admin.
  //
  // The user can be missing here if the initial user fetch failed (e.g. an expired/invalid token that
  // could not be renewed). Guard against it so we don't crash the whole app; the axios 401 handler will
  // drive re-login.
  const config = canSeeConfig[firstRole(user) as keyof typeof canSeeConfig];
  if (!config) {
    return null;
  }

  return <Navigate replace to={`/${config.defaultPageUrl}`} />;
}
